import React from 'react';
import { Card, CardHeader, CardBody, Container, Row, Col } from 'reactstrap';
import i18n from '../../utils/i18n';
import { getWithExpiry, setWithExpiry } from '../../utils/helpers';

const ErrorFallback = ({ error }) => {
  localStorage.removeItem('gh.adminGc');

  const chunkFailedMessage = /Cannot read properties of undefined/;
  if (error?.message && chunkFailedMessage.test(error.message)) {
    if (!getWithExpiry('gh.chunk-failed')) {
      setWithExpiry('gh.chunk-failed', 'true', 10000);
      window.location.reload();
    }
  }

  return (
    <Container fluid>
      <Row>
        <Col>
          <div className="card-wrapper mt-5">
            <Card>
              <CardHeader>
                <h3 className="mb-0">{i18n.t('error.fallback-title')}</h3>
              </CardHeader>
              <CardBody>
                <p>{i18n.t('error.fallback-text')}</p>
                <a href="/golfclub-admin/dashboard">{i18n.t('error.to-club-admin')}</a>
              </CardBody>
            </Card>
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default ErrorFallback;
